<template>
  <div>
    <!-- <span class="weui-switch" :class="{ 'weui-switch-on': isChecked }" :value="value" @click="toggle"
      style="position:relative">
      <div v-if="isChecked && direction.length > 0"
        style="width:100%;height:100%;position:absolute;padding:0 5px;line-height:20px;color:#FFF;user-select:none">
        {{ direction[0] }}
      </div>
      <div v-if="!isChecked && direction.length > 0"
        style="width:100%;height:100%;position:absolute;padding:0 5px;right:2px;line-height:20px;color:#7A7A7A;text-align:right;user-select:none">
        {{ direction[1] }}
      </div>
    </span> -->
    <i-switch :value="Boolean(isChecked)" @on-change="toggle"></i-switch>
  </div>
</template>
<script>
export default {
  name: "switchComponents",
  props: {
    value: {
      default: true
    },
    text: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      isChecked: this.value
    };
  },
  computed: {
    direction () {
      if (this.text)
      {
        return this.text.split("|");
      } else
      {
        return [];
      }
    }
  },
  watch: {
    value (val) {
      this.isChecked = val;
    }
    //   isChecked(val) {
    //     this.$emit('change', val);
    //   }
  },
  methods: {
    toggle () {
      this.isChecked = !this.isChecked;
      this.$emit("change", this.isChecked);
    }
  }
};
</script>
<style lang="scss" scoped>
.weui-switch {
  display: block;
  position: relative;
  width: 46px;
  height: 22px;
  border: 1px solid #dfdfdf;
  outline: 0;
  border-radius: 16px;
  box-sizing: border-box;
  background-color: #dfdfdf;
  transition: background-color 0.1s, border 0.1s;
  cursor: pointer;
}

.weui-switch:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  width: 44px;
  height: 20px;
  border-radius: 15px;
  background-color: #fdfdfd;
  transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
}

.weui-switch:after {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
}

.weui-switch-on {
  border-color: #1aad19;
  background-color: #1aad19;
}

.weui-switch-on:before {
  border-color: #1aad19;
  background-color: rgb(51, 204, 0);
}

.weui-switch-on:after {
  transform: translateX(24px);
}

.ivu-switch-checked {
  border-color: #1aad19;
  background-color: rgb(51, 204, 0);
}
</style>
